import { render, staticRenderFns } from "./tx.vue?vue&type=template&id=574aefc4&scoped=true&"
import script from "./tx.vue?vue&type=script&lang=js&"
export * from "./tx.vue?vue&type=script&lang=js&"
import style0 from "./tx.vue?vue&type=style&index=0&id=574aefc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574aefc4",
  null
  
)

export default component.exports